<template lang="pug">
  Auth(@loggedIn="onLoggedIn")
    div(v-if="avatar").wrap-module-chat
      div.wrap-profile
        ItemAvatarProfile(:avatar="avatar" :user="user")
      div.tab.f.fh
        span ツイート
      div.wrap-cards
        ItemPostCard(v-for="card in cards" :card="card" :avatar="avatar")

</template>

<style lang="scss" scoped>
.wrap-module-chat {
  .tab {
    width: 100%;
    height: 28px;
    border-bottom: solid 1px #ff9999;
    span {
      color: #ff9999;
      font-weight: bold;
    }
  }
  .wrap-cards {
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
import Auth from '@/components/auth'
import ItemAvatarProfile from '@/components/item/ItemAvatarProfile'
import ItemPostCard from '@/components/item/ItemPostCard'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    Auth,
    ItemAvatarProfile,
    ItemPostCard
  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  props: {

  },
  data () {
    return {
      user: null,
      avatar: null,
      cards: [],
      showNowLoading: false
    }
  },
  async created () {
    this.avatar = await db.collection('avatars')
      .doc(this.$route.params.id)
      .get()
      .then((d) => {
        var avatar = d.data()
        avatar.id = d.id
        return avatar
      })

    this.cards = await db.collection('posts')
      .orderBy('createdAt', 'desc')
      .limit(200)
      .get()
      .then((q) => {
        return q.docs.map((d) => {
          var card = d.data()
          card.id = d.id
          return card
        })
      })

    this.$emit('hideNowLoading')
  },
  methods: {
    // ...mapActionsTeam([
    //   'loadMemberUsers'
    // ])
    async onLoggedIn () {
      if (!this.isAnonymous) {
        this.user = await db.collection('users')
          .doc(this.uid)
          .get()
          .then((d) => {
            var user = d.data()
            user.uid = d.id
            return user
          })
      }
    }
  }
}
</script>
